import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ThirdPartTrackingCodes } from "../models/global-config.model";
import { AnonymousPortalSettings } from "../models/anonymous-portal-settings.model";
import { AnonymousLegalDocuments } from "../models/anonymous-legal-documents.model";
import { DataService } from "./data.service";

@Injectable()
export class GlobalConfigService {

  constructor(private readonly _dataService: DataService) {
  }

  getThirPartTrackingCodes = (companyGuid: string): Observable<ThirdPartTrackingCodes> => {
    const url = `api/online-app/3rd-party-tracking-codes/${companyGuid}`;
    return this._dataService.getWithoutAuth(url);
  }

  // Anonymous public portal settings, per companyGuid (sibling of getThirPartTrackingCodes).
  getAnonymousPortalSettings = (companyGuid: string): Observable<AnonymousPortalSettings> => {
    const url = `api/BorrowerPortal/companies/${companyGuid}/portal-settings/anonymous-portal-settings`;
    return this._dataService.getWithoutAuth(url);
  }

  // Same settings as getAnonymousPortalSettings, but the server resolves the company from the
  // request's Referer header instead of a companyGuid. Used when no companyGuid is on the URL.
  getAnonymousPortalSettingsByReferrer = (): Observable<AnonymousPortalSettings> => {
    const url = `api/BorrowerPortal/portal-settings/anonymous-portal-settings-by-referrer`;
    return this._dataService.getWithoutAuth(url);
  }

  // Lender-configured Terms of Use / Privacy Policy (EN + ES). Kept out of the anonymous
  // portal-settings bag, which is fetched on every page and cached in localStorage.
  getAnonymousLegalDocuments = (companyGuid: string): Observable<AnonymousLegalDocuments> => {
    const url = `api/BorrowerPortal/companies/${companyGuid}/portal-settings/anonymous-legal-documents`;
    return this._dataService.getWithoutAuth(url);
  }

  getAnonymousLegalDocumentsByReferrer = (): Observable<AnonymousLegalDocuments> => {
    const url = `api/BorrowerPortal/portal-settings/anonymous-legal-documents-by-referrer`;
    return this._dataService.getWithoutAuth(url);
  }

  getClientIp(): Observable<{ ip: string; }> {
    return this._dataService.getExternalApi('https://api.ipify.org?format=json');
  }
}
